<app-page-meta pageTitle="finzy - Preferences"></app-page-meta>
<app-header></app-header>
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-11 col-lg-11 col-lg-offset-1 full-width-space padding-wrapper margin-wrapper">
            <div class="heading">
                <p>finzyFLEX Investment Preferences</p>
            </div>
            <div class="heading-discription">
                <p>
                    Set your preferences to automatically invest and to receive periodical payouts from finzy. You may
                    choose to change them any point in time.
                </p>
            </div>
            <hr class="hrcust" />

            <!-- ======================================    Swift start  ======================================  -->

            <div class="row add-spacing">
                <div class="col-sm-4 preference-text-wrap full-width-space">
                    <div class="sub-heading">
                        <p>Swift</p>
                    </div>
                    <div class="sub-heading-discription">
                        <p>
                            Swift is a convenient investment option allowing you to automatically invest your wallet
                            funds into loan(s) without any intervention from your end. Click here to <a
                                href="faq?selectedTab=FINZY_FLEX&preferenceType=swift" target="_blank" class="link">Know
                                More</a>
                        </p>
                    </div>
                </div>
                <div class="col-sm-8 products-name pl-0">
                    <div class="product-container">
                        <div class="product-header-box">
                            <div class="col-xs-9 col-sm-10 preference-header">
                                <span class="product-header">Enable Swift</span>
                            </div>
                            <div class="col-xs-3 col-sm-2 text-right preference-toggle">
                                <mat-slide-toggle [ngModel]="isSwiftEnabled" (change)="onSwiftToggle()" color="primary">
                                </mat-slide-toggle>
                            </div>
                        </div>
                        <div *ngIf="isSwiftEnabled && isPreviousSwiftAvailable" class="row mb-4 add-margin1">
                            <div class="col-xs-8 col-sm-9 swift-products">
                                <div class="col-xs-4 col-sm-3 mt-4 swift-product" *ngFor="let product of products">
                                    <div class="swift-product-code">{{product.productCode}}</div>
                                    <div class="swift-attribute-value">{{product.attributeValue}} %</div>
                                </div>
                            </div>
                            <div class="col-xs-4 col-sm-3 text-right swift-edit-btn">
                                <button class="edit-button" (click)="onClickSwiftEditBtn()">EDIT</button>
                            </div>
                        </div>
                        <div *ngIf="isSwiftEnabled && !isPreviousSwiftAvailable" class="mb-4">
                            <app-swift-attribute [userAttributesSwiftForm]="userAttributesSwiftForm"
                                [isSwiftEnabled]="isSwiftEnabled" 
                                [applicableProducts]="product.data"
                                [backupSwiftAttribute]="backupSwiftAttribute"
                                [havePreferencesChanged]="havePreferencesChanged"
                                [previousUserAttribute]="previousUserAttribute"
                                (changeValue)="changeDisplaySaveValue($event)" 
                                [userAttributes]="userAttributes"
                                [userAttributesForm]="userAttributesForm">
                            </app-swift-attribute>
                        </div>
                    </div>
                </div>
            </div>
            <hr class="hrcust" />

            <!-- ======================================    nCash start   ======================================  -->

            <div class="row add-spacing">
                <form [formGroup]="userAttributesForm" class="nCash-form">
                    <div class="col-sm-4 preference-text-wrap full-width-space nCash-text-wrapper">
                        <div class="sub-heading">
                            <p>nCash</p>
                        </div>
                        <div class="sub-heading-discription">
                            <p>
                                nCash provides you an option to withdraw a fixed or a customized amount periodically
                                from your investments. Click here to <a
                                    href="faq?selectedTab=FINZY_FLEX&preferenceType=nCash" target="_blank"
                                    class="link">Know More</a>
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-8 products-name nCash-details-wrapper pl-0">
                        <div class="product-container">
                            <div class="product-header-box">
                                <div class="col-xs-9 col-sm-10 preference-header">
                                    <p class="product-header">Enable nCash</p>
                                </div>
                                <div class="col-xs-3 col-sm-2 text-right preference-toggle">
                                    <mat-slide-toggle [ngModel]="isNCashEnabled" [ngModelOptions]="{standalone: true}"
                                        (change)="onNCashToggle()" color="primary">
                                    </mat-slide-toggle>
                                </div>
                            </div>
                            <div *ngIf="isNCashEnabled" class="row m-0">
                                <div class="ncash-body row">
                                    <div class="col-xs-12">
                                        <p>Set the nCash amount you want to receive periodically</p>
                                    </div>
                                </div>

                                <!-- ======================================  Max nCash start  ======================================  -->

                                <mat-accordion>
                                    <mat-expansion-panel class="mat-elevation-z0 expansion-panel" [disabled]="true"
                                        [expanded]="setPannel === 0">
                                        <mat-expansion-panel-header (click)="setPannelHeader(0)" class="pannel-header">
                                            <input type="radio" value="MAX_LIMIT" id="id0" formControlName="nCash"
                                                name="nCash" [(ngModel)]="selectedNCashType"
                                                (change)="updateSelectedNCashTypeChange()" />
                                            <label for="id0">Max nCash
                                                <div class="category-description"
                                                    [class.category-description-ellipsis]="setPannel !== 0">
                                                    <p>
                                                        You can choose to receive maximum permissible amount based on
                                                        the frequency selected. Max nCash amount is determined by finzy
                                                        on the basis of your finzyFLEX investment outstanding.
                                                    </p>
                                                </div>
                                            </label>
                                        </mat-expansion-panel-header>
                                        <div *ngIf="selectedNCashType === 'MAX_LIMIT' && userPreviousNCashType === 'MAX_LIMIT'"
                                            class="row mb-4 add-margin1">
                                            <div class="row col-sm-9">
                                                <div class="col-xs-6 col-sm-4 mt-4"
                                                    *ngFor="let nCashAttribute of userPreviousAttributes">
                                                    <div class="ncash-attribute-key">{{nCashAttribute.key}}</div>
                                                    <div class="ncash-attribute-value">{{nCashAttribute.value}}</div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3 text-right swift-edit-btn">
                                                <button class="edit-button" (click)="onClickEditBtn()">EDIT</button>
                                            </div>
                                        </div>
                                        <app-max-n-cash-attribute
                                            *ngIf="selectedNCashType === 'MAX_LIMIT' && userPreviousNCashType !== 'MAX_LIMIT'"
                                            [userAttributes]="userAttributes" [userAttributesForm]="userAttributesForm"
                                            [havePreferencesChanged]="havePreferencesChanged"
                                            [previousUserAttribute]="previousUserAttribute"
                                            (changeValue)="changeDisplaySaveValue($event)"
                                            [userAttributesSwiftForm]="userAttributesSwiftForm"
                                            [isSwiftEnabled]="isSwiftEnabled"
                                            [backupSwiftAttribute]="backupSwiftAttribute">
                                        </app-max-n-cash-attribute>
                                    </mat-expansion-panel>

                                    <!-- ======================================  Custom nCash start  ======================================  -->

                                    <mat-expansion-panel class="mat-elevation-z0 expansion-panel" [disabled]="true"
                                        [expanded]="setPannel === 1">
                                        <mat-expansion-panel-header (click)="setPannelHeader(1)" class="pannel-header">

                                            <input type="radio" value="CUSTOM" id="id1" formControlName="nCash"
                                                [attr.disabled]="(maxNCashAmount < 100) ? false : null" name="nCash"
                                                [(ngModel)]="selectedNCashType"
                                                (change)="updateSelectedNCashTypeChange()" />
                                            <label for="id1">Custom nCash
                                                <div class="category-description"
                                                    [class.category-description-ellipsis]="setPannel !== 1">
                                                    <p>
                                                        You can choose to receive amount of you choice within maximum
                                                        permissible limit
                                                    </p>
                                                </div>
                                            </label>
                                        </mat-expansion-panel-header>
                                        <div *ngIf="selectedNCashType === 'CUSTOM' && userPreviousNCashType === 'CUSTOM'"
                                            class="row mb-4 add-margin1">
                                            <div class="row col-sm-10">
                                                <div class="col-xs-6 col-sm-4 mt-4"
                                                    *ngFor="let nCashAttribute of userPreviousAttributes">
                                                    <div class="ncash-attribute-key">{{nCashAttribute.key}}</div>
                                                    <div class="ncash-attribute-value">{{nCashAttribute.value}}</div>
                                                </div>
                                            </div>
                                            <div class="col-sm-2 text-right swift-edit-btn">
                                                <button class="edit-button" (click)="onClickEditBtn()">EDIT</button>
                                            </div>
                                        </div>
                                        <app-custom-n-cash-attribute
                                            *ngIf="selectedNCashType === 'CUSTOM' && userPreviousNCashType !== 'CUSTOM'"
                                            [userAttributes]="userAttributes" [userAttributesForm]="userAttributesForm"
                                            [customNCashAmount]="customNCashAmount"
                                            [havePreferencesChanged]="havePreferencesChanged"
                                            [previousUserAttribute]="previousUserAttribute"
                                            (changeValue)="changeDisplaySaveValue($event)"
                                            [userAttributesSwiftForm]="userAttributesSwiftForm"
                                            [isSwiftEnabled]="isSwiftEnabled"
                                            [backupSwiftAttribute]="backupSwiftAttribute">
                                        </app-custom-n-cash-attribute>
                                    </mat-expansion-panel>

                                    <!-- ======================================   Interest Only  start ======================================  -->

                                    <mat-expansion-panel class="mat-elevation-z0 expansion-panel" [disabled]="true"
                                        [expanded]="setPannel === 2">
                                        <mat-expansion-panel-header (click)="setPannelHeader(2)" class="pannel-header">
                                            <input type="radio" value="INTEREST_ONLY" id="id2" formControlName="nCash"
                                                name="nCash" [(ngModel)]="selectedNCashType"
                                                (change)="updateSelectedNCashTypeChange()" />
                                            <label for="id2">Interest Only
                                                <div class="category-description"
                                                    [class.category-description-ellipsis]="setPannel !== 2">
                                                    <p>
                                                        You can choose to receive your interest earned periodically
                                                    </p>
                                                </div>
                                            </label>
                                        </mat-expansion-panel-header>
                                        <div *ngIf="selectedNCashType === 'INTEREST_ONLY' && userPreviousNCashType === 'INTEREST_ONLY'"
                                            class="row mb-4 add-margin1">
                                            <div class="row col-sm-9">
                                                <div class="col-xs-6 col-sm-4 mt-4"
                                                    *ngFor="let nCashAttribute of userPreviousAttributes">
                                                    <div class="ncash-attribute-key">{{nCashAttribute.key}}</div>
                                                    <div class="ncash-attribute-value">{{nCashAttribute.value}}</div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3 text-right swift-edit-btn">
                                                <button class="edit-button" (click)="onClickEditBtn()">EDIT</button>
                                            </div>
                                        </div>
                                        <app-interest-only-n-cash-attribute
                                            *ngIf="selectedNCashType === 'INTEREST_ONLY' && userPreviousNCashType !== 'INTEREST_ONLY'"
                                            [userAttributes]="userAttributes" [userAttributesForm]="userAttributesForm"
                                            [havePreferencesChanged]="havePreferencesChanged"
                                            [previousUserAttribute]="previousUserAttribute"
                                            (changeValue)="changeDisplaySaveValue($event)"
                                            [userAttributesSwiftForm]="userAttributesSwiftForm"
                                            [isSwiftEnabled]="isSwiftEnabled"
                                            [backupSwiftAttribute]="backupSwiftAttribute">
                                        </app-interest-only-n-cash-attribute>
                                    </mat-expansion-panel>
                                </mat-accordion>
                                <div class="col-xs-12" *ngIf="userAttributesForm.controls.nCash.invalid">
                                    <span class="error-text">Please choose any one of the nCash option</span>
                                </div>

                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <hr class="hrcust" />

            <!--======================================= Loan Preferences start ============================= -->

            <div class="row add-spacing">
                <form [formGroup]="userAttributesForm" class="loan-preference-form">
                    <div class="col-sm-4 preference-text-wrap full-width-space">
                        <div class="sub-heading">
                            <p>Loan Preferences</p>
                        </div>
                        <div class="sub-heading-discription">
                            <p>
                                You can choose your preferred loan rating categories below. This master FLEX Loan
                                preference will be used to find loans for any Swift, Auto and Pro reinvestment into Flex
                                portfolios that are created.
                                <br>
                                Your customisation will be applied to portfolios that are created after you save your
                                preference here.
                            </p>
                        </div>
                    </div>
                    <div *ngIf="showFormPreferenceForm" class="col-sm-8 products-name pl-0" formGroupName="loanPreference">
                        <div class="product-container">
                            <div class="product-header-box">
                                <div class="col-xs-9 col-sm-10 preference-header">
                                    <span class="product-header">Loan Preferences</span>
                                </div>
                            </div>

                            <div class="row loan-preference-content-margin">
                                <div class="my-3 pannel-header padding-25px border-radius-6px">
                                    <div class="sub-heading">
                                        <p class="font-bold text-left m-0">Maximum Loan Amount</p>
                                    </div>
                                    <div class="sub-heading-discription">
                                        Maximum loan amount you want to invest in one loan
                                    </div>
                                    <div class="mt-2">
                                        <mat-button-toggle-group 
                                            name="maxLoanAmount" 
                                            aria-label="loanAmountMax"
                                            class="border-0" 
                                            [value]="maxLoanAmountToggle"
                                            (change)="maxLoanAmountChange($event)">
                                            <div class="mb-1">
                                                <div class="col-xs-12 col-sm-6 col-lg-4 col-xl-3 mt-3 p-0 pr-2">
                                                    <mat-button-toggle class="rounded-1 common-button px-0 maxLoanAmountPref" value="1">
                                                        1% of portfolio amount
                                                    </mat-button-toggle>
                                                </div>
                                                <div class="col-xs-12 col-sm-6 col-lg-4 col-xl-3 mt-3 p-0 pr-2">
                                                    <mat-button-toggle class="rounded-1  common-button px-0 maxLoanAmountPref" value="2">
                                                        2% of portfolio amount
                                                    </mat-button-toggle>
                                                </div>
                                                <div class="col-xs-12 col-sm-6 col-lg-4 col-xl-3 mt-3 p-0 pr-2">
                                                    <mat-button-toggle class="rounded-1  common-button px-0 maxLoanAmountPref" value="5">
                                                        5% of portfolio amount
                                                    </mat-button-toggle>
                                                </div>
                                                <div class="col-xs-12 col-sm-6 col-lg-4 col-xl-3 mt-3 p-0">
                                                    <mat-button-toggle class="rounded-1  common-button px-0 maxLoanAmountPref" value="10">
                                                        10% of portfolio amount
                                                    </mat-button-toggle>
                                                </div>
                                            </div>
                                        </mat-button-toggle-group>
                                    </div>

                                </div>

                                <div class="my-3 pannel-header padding-25px border-radius-6px">
                                    <div class="sub-heading">
                                        <p class="font-bold text-left m-0">Loan Tenure Preference</p>
                                    </div>
                                    <div class="sub-heading-discription">
                                        Select the loan tenure you want to invest in
                                    </div>
                                    <div class="mt-2">
                                        <mat-button-toggle-group 
                                            name="tenurePreference" 
                                            aria-label="preferred tenure"
                                            class="border-0" 
                                            [value]="tenurePreferenceToggle"
                                            (change)="preferredTenureChange($event)">
                                            <div class="mb-1">
                                                <div class="col-xs-12 col-sm-6 col-lg-4 col-xl-3 mt-3 p-0 pr-2">
                                                    <mat-button-toggle class="rounded-1 common-button px-0"
                                                        value="12">Less than 12 months</mat-button-toggle>
                                                </div>
                                                <div class="col-xs-12 col-sm-6 col-lg-4 col-xl-3 mt-3 p-0 pr-2">
                                                    <mat-button-toggle class="rounded-1  common-button px-0"
                                                        value="24">Less than 24 months</mat-button-toggle>
                                                </div>
                                                <div class="col-xs-12 col-sm-6 col-lg-4 col-xl-3 mt-3 p-0 pr-2">
                                                    <mat-button-toggle class="rounded-1  common-button px-0"
                                                        value="36">Less than 36 months</mat-button-toggle>
                                                </div>
                                            </div>
                                        </mat-button-toggle-group>
                                    </div>
                                    <div class="sub-heading-discription">
                                        Loan tenure preference will automatically change Based on
                                        the Sub-Product's MHP/Maturity
                                    </div>
                                </div>

                                <div class="my-3 pannel-header padding-25px border-radius-6px">
                                    <div class="interest-rate-section">
                                        <div class="sub-heading">
                                            <p class="font-bold text-left m-0">Interest Rate & Risk Range</p>
                                        </div>
                                        <div class="sub-heading-discription">
                                            You can choose the minimum 2 interest rate and risk range from below
                                        </div>
                                        <div class="mt-2">
                                            <mat-button-toggle-group 
                                                name="interestRate"
                                                aria-label="Interest rate & risk range" 
                                                class="border-0"
                                                [value]="interestRateRiskRangeToggle"
                                                (change)="interestRateChange($event, true)"
                                                multiple>
                                                <div>
                                                    <div class="col-xs-12 col-sm-6 col-lg-4 col-xl-3 mt-3 p-0 pr-2">
                                                        <mat-button-toggle class="d-flex flex-column py-3 border"
                                                            style="border-radius: 5px;" value="A1-A6">
                                                            <p style="line-height: normal;" class="mb-0">Low Risk (A1-A6)</p>
                                                            <small class="d-block button-subheading" style="line-height: normal;">10.99% to 15.99%</small>
                                                        </mat-button-toggle>
                                                    </div>
    
                                                    <div class="col-xs-12 col-sm-6 col-lg-4 col-xl-3 mt-3 p-0 pr-2">
                                                        <mat-button-toggle class="d-flex flex-column py-3 border B1-B6"
                                                            style="border-radius: 5px;" value="B1-B6">
                                                            <p style="line-height: normal;" class="mb-0 mr-xl-5">Medium Risk (B1-B6)</p>
                                                            <small class="d-block button-subheading ml-xl-4" style="line-height: normal;">16.99% to 21.99%</small>
                                                        </mat-button-toggle>
                                                    </div>
    
                                                    <div class="col-xs-12 col-sm-6 col-lg-4 col-xl-3 mt-3 p-0 pr-2">
                                                        <mat-button-toggle class="d-flex flex-column py-3 border"
                                                            style="border-radius: 5px;" value="C1-C6">
                                                            <p style="line-height: normal;" class="mb-0">High Risk (C1-C6)</p>
                                                            <small class="d-block button-subheading" style="line-height: normal;">22.99% to 27.99%</small>
                                                        </mat-button-toggle>
                                                    </div>
                                                </div>
                                            </mat-button-toggle-group>
                                        </div>
                                    </div>

                                    <div *ngIf="userAttributesForm.get('loanPreference.interestRateRiskRange').status === 'INVALID'">
                                        <span class="error-text">Please select minimum two interest rate & risk range</span>
                                    </div>

                                    <div class="expected-return-section my-3">
                                        <div class="sub-heading">
                                            <p class="font-bold text-left m-0">
                                                Expected Return
                                                <span class="text-muted font-weight-normal">(per annum)</span>
                                            </p>
                                        </div>
                                        <div class="sub-heading-discription">
                                            Expected return calculated based on your Interest Rate &
                                            Risk Range selection
                                        </div>
                                        <div class="row mt-3 mx-0">
                                            <ng-container *ngIf="riskScore">
                                                <div class="col-xs-6 col-sm-3 col-12 p-0 pr-2 mt-2" *ngFor="let item of getProductFromRiskScore()">
                                                    <button class="w-100 rounded-1 common-button d-flex justify-content-between align-items-center height-50px p-1 pl-4">
                                                        <ng-container *ngIf="getProductCodeVariantCategory(item,userAttributesForm.get('loanPreference.expectedReturn.'+ item).value).productCode">
                                                            <span class="d-flex">
                                                                {{getProductCodeVariantCategory(item,userAttributesForm.get('loanPreference.expectedReturn.'+ item).value).productCode}}
                                                                <ng-container *ngIf="getProductCodeVariantCategory(item,userAttributesForm.get('loanPreference.expectedReturn.'+ item).value).category">
                                                                    <small class="extra-small-text font-weight-bold ng-star-inserted mt-1 ml-1">
                                                                        {{getProductCodeVariantCategory(item,userAttributesForm.get('loanPreference.expectedReturn.'+ item).value).category}}
                                                                    </small>
                                                                </ng-container>
                                                            </span>
                                                        </ng-container>

                                                        <div class="expected-return-roi-bg">
                                                            <ng-container *ngIf="!userAttributesForm.get('loanPreference.expectedReturn.'+ item).value; else showPercentageValue">
                                                                <mat-icon>minimize</mat-icon>
                                                            </ng-container>
                                                            <ng-template #showPercentageValue class="text-success font-bold">
                                                                <span class="text-success font-bold">
                                                                    {{userAttributesForm.get('loanPreference.expectedReturn.'+ item).value}}%
                                                                </span>
                                                            </ng-template>
                                                        </div>
                                                    </button>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <hr class="hrcust" />

            <!-- ======================================    Email Notifications start   ======================================  -->

            <div class="row add-spacing">
                <div class="col-sm-4 preference-text-wrap full-width-space">
                    <div class="sub-heading">
                        <p>Email Notifications </p>
                    </div>
                    <div class="sub-heading-discription">
                        <p *ngIf="!isEmailEnabled">
                            You will not receive email notifications for new loans allocated to any of your finzyFLEX
                            investments. The option to reverse any individual loan allocation (within the reversal
                            expiry time limit) will continue to be available from the <strong class="black-text">Loans
                                Tab</strong> on your dashboard. If you wish to receive these email notifications, you
                            can turn on this preference at any point.
                        </p>
                        <p *ngIf="isEmailEnabled">
                            You will receive an email notification every time a new loan is allocated to one of your
                            finzyFLEX investment portfolios. If you wish to stop receiving these emails, you can turn
                            off this preference at any point. The option to reverse any individual loan allocation
                            (within the reversal expiry time limit) will continue to be available from the Allocated
                            Loans listing on your dashboard.
                        </p>
                    </div>
                </div>
                <div class="col-sm-8 products-name pl-0">
                    <div class="product-container">
                        <div class="product-header-box">
                            <div class="col-xs-9 col-sm-10 preference-header">
                                <p class="product-header">Email Notifications</p>
                            </div>
                            <div class="col-xs-3 col-sm-2 text-right preference-toggle">
                                <mat-slide-toggle [checked]="isEmailEnabled" (change)="onEmailToggle()" color="primary">
                                </mat-slide-toggle>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <!-- ======================================   submit button bar   ======================================  -->

            <div class="footer" *ngIf="submitBar">
                <div class="modal-footer col-lg-10 col-sm-offset-1">
                    <div *ngIf="!dataLoader" class="button-wrapper">
                        <button type="button" class="set-up-later-btn" (click)="setUpLater()">SET UP LATER</button>
                        <button type="button" class="save-btn" (click)="submit()"
                            [disabled]="userAttributesForm.invalid || userAttributesSwiftForm.invalid || disableSave">SAVE</button>
                    </div>
                    <div *ngIf="dataLoader" class="loader">
                        <mat-spinner [diameter]="35"></mat-spinner>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>